import { interpolateTemplate } from "lib/i18n/dictionary";

import { notifyError, notifySuccess } from "./site.notify";
import { claudePromptUrl } from "./site-assistant";
import {
  useCreateSiteAssistantPairing,
  useDisconnectSiteAssistant,
  useMySiteAssistant,
} from "./site.hooks";
import { openInNewTab, openUrl } from "./site.web";
import { useSiteTranslations } from "./use-site-translations";

// The Provider's own Claude on their site: "Підключити Claude" opens Claude's connector install
// link with a one-time code; the Provider then allows it on the request page.
export function useSiteAssistantConnection() {
  const { t } = useSiteTranslations();
  const { data } = useMySiteAssistant();
  const [createPairing, { loading: isCreating }] = useCreateSiteAssistantPairing();
  const [disconnect, { loading: isDisconnecting }] = useDisconnectSiteAssistant();
  const connection = data?.mySiteAssistant.connections[0] ?? null;

  async function onConnect() {
    try {
      await openInNewTab(async () => {
        const { data: created } = await createPairing();
        if (!created) throw new Error("No pairing link");
        return created.siteAssistantCreatePairing.installUrl;
      });
    } catch {
      notifyError(t.errors.sendFailedTitle, t.errors.tryAgain);
    }
  }

  async function onDisconnect(client: string) {
    try {
      await disconnect();
      notifySuccess(interpolateTemplate(t.assistant.disconnected, { client }), "", t.title);
    } catch {
      notifyError(t.assistant.disconnect, t.errors.tryAgain);
    }
  }

  return { connection, onConnect, isCreating, onDisconnect, isDisconnecting };
}

// "Створити сайт з Claude" / "Змінити дизайн з Claude": the Provider's own Claude with a ready
// request naming Matcha, so it reaches for the Matcha Events Site tools. `siteHost`: the site's
// address when it has one.
export function useOpenClaude() {
  const { t } = useSiteTranslations();
  return (siteHost: string | null) =>
    openUrl(
      claudePromptUrl(
        siteHost
          ? interpolateTemplate(t.assistant.prompt.change, { site: siteHost })
          : t.assistant.prompt.create
      )
    );
}
